import { Injectable } from '@angular/core';
import firebase from 'firebase';

@Injectable()
export class FirestoreService {
  days = [
    'Monday',
    'Tueday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
  ];

  months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  constructor() {}

  addUser(userId: string, email: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .set(
          {
            name: email
          },
          { merge: true }
        )
        .then(function() {
          resolve();
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  addDevice(userId: string, uuid) {
    let currentDevice = localStorage.getItem('deviceUuid');

    if(currentDevice == null) {
      localStorage.setItem('deviceUuid', uuid);

      const promise = new Promise((resolve, reject) => {
        const db = firebase.firestore();

        db.collection('users')
          .doc(userId)
          .collection('myDevices')
          .doc()
          .set({
            uuid: uuid,
            name: 'device_'+uuid
          })
          .then(function() {
            resolve();
          })
          .catch(function(error) {
            console.error(error);
            reject(error);
          });
      });

      return promise;
    }
  }

  getWatchedMovies(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      // only get the latest 10 recent searches
      db.collection('users')
        .doc(userId)
        .collection('recentlyWatchedMovies')
        .get()
        .then(myHistorySnapshot => {
          const myHistory = [];

          myHistorySnapshot.forEach(doc => {
            myHistory.push(doc.data());
          });

          resolve({ myHistory: myHistory });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  /*
  deleteUser(userId: string) {

    const promise = new Promise((resolve, reject) => {
      admin.auth().deleteUser(userId).then(() => {
        resolve();
      })
      .catch(function(error) {
        console.error(error);
        reject(error);
      });
    });

    return promise;
  }
*/



  getWatchedShows(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      // only get the latest 10 recent searches
      db.collection('users')
        .doc(userId)
        .collection('recentlyWatchedTvShows')
        .get()
        .then(myHistorySnapshot => {
          const myHistory = [];

          myHistorySnapshot.forEach(doc => {

            myHistory.push(doc.data());
          });

          resolve({ myHistory: myHistory });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }



  getMyDevices(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      // only get the latest 10 recent searches
      db.collection('users')
        .doc(userId)
        .collection('myDevices')
        .get()
        .then(myDevicesSnapshot => {
          const myDevices = [];

          myDevicesSnapshot.forEach(doc => {
            const device: any = {};

            device.id = doc.id;
            device.uuid = doc.data().uuid;
            device.name = doc.data().name;

            myDevices.push(device);
          });

          resolve({ myDevices: myDevices });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }


  getUserDetails(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      // only get the latest 10 recent searches
      db.collection('users')
        .doc(userId)
        .get()
        .then(details => {
          resolve({ details: details.data() });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }




  getPaymentsHistory(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      // only get the latest 10 recent searches
      db.collection('users')
        .doc(userId)
        .collection('paymentsHistory')
        .get()
        .then(paymentsHistorySnapshot => {
          const myDetails = [];

          paymentsHistorySnapshot.forEach(doc => {
            const detail: any = {};

            detail.id = doc.id;
            detail.addedAt = doc.data().addedAt;
            detail.paymentInfo = JSON.parse(doc.data().paymentInfo);

            myDetails.push(detail);
          });

          resolve({ myDetails: myDetails });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }



  removeDevice(userId: string, deviceRef) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('myDevices')
        .doc(deviceRef)
        .delete()
        .then(() => {

          //this.authService.handleAccountLoginsOnLogout();
          resolve();
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }


  removeDeviceWithUUID(userId: string, uuid) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('myDevices')
        .get()
        .then(myDevicesSnapshot => {

          myDevicesSnapshot.forEach(doc => {
            const device: any = {};
            device.uuid = doc.data().uuid;

            if(device.uuid == uuid) {
              this.removeDevice(userId, doc.id)
            }
          });

        })
        .catch(function(error) {
          reject(error);
        });

    });

    return promise;
  }


  addToRecentlyWatchedMovies(userId: string, video: any) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentlyWatchedMovies')
        .doc(video.movieId)
        .set({
          addedAt: firebase.firestore.FieldValue.serverTimestamp(),
          detailsPicture: video.detailsPicture,
          description: video.description,
          name: video.name,
          picture: video.picture,
          rating: video.rating,
          releaseYear: video.releaseYear,
          videoUrl: video.videoUrl
        })
        .then(function() {
          resolve();
        })
        .catch(function(error) {
          console.error(error);
          reject(error);
        });
    });

    return promise;
  }

  addToRecentlyWatchedMoviesAgain(userId: string, movieId: any, watchCount) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentlyWatchedMovies')
        .doc(movieId)
        .set({
          addedAt: firebase.firestore.FieldValue.serverTimestamp(),
          watchCount: watchCount
        }, { merge: true })
        .then(function() {
          resolve();
        })
        .catch(function(error) {
          console.error(error);
          reject(error);
        });
    });

    return promise;
  }

  updateMovieWatchProgress(userId: string, video: any, watchProgress) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentlyWatchedMovies')
        .doc(video.movieId)
        .set({
          addedAt: firebase.firestore.FieldValue.serverTimestamp(),
          watchProgress: watchProgress
        }, { merge: true })
        .then(function() {
          resolve();
        })
        .catch(function(error) {
          console.error(error);
          reject(error);
        });
    });

    return promise;
  }

  updateTvShowWatchProgress(userId: string, tvShowId: string, watchProgress, watchCount) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentlyWatchedTvShows')
        .doc(tvShowId)
        .set({
          addedAt: firebase.firestore.FieldValue.serverTimestamp(),
          watchProgress: watchProgress,
          watchCount: watchCount
        }, { merge: true })
        .then(function() {
          resolve();
        })
        .catch(function(error) {
          console.error(error);
          reject(error);
        });
    });

    return promise;
  }


  addToRecentlyWatchedTvShows(userId: string, video: any, seasonId: string, seasonName: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentlyWatchedTvShows')
        .doc(video.tvShowId)
        .set({
          addedAt: firebase.firestore.FieldValue.serverTimestamp(),
          //description: video.description,
          name: video.name,
          picture: video.picture,
          seasonId: seasonId,
          seasonName: seasonName,
          tvShowId: video.tvShowId,
          tvShowName: video.tvShowName,
          videoUrl: video.videoUrl,
          watchCount: 1
        })
        .then(function() {
          resolve();
        })
        .catch(function(error) {
          console.error(error);
          reject(error);
        });
    });

    return promise;

  }

  addToRecentlyWatchedTvShowsAgain(userId: string, tvShowId: string, watchCount) {
    console.log('-----------tv watch count-----------')
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentlyWatchedTvShows')
        .doc(tvShowId)
        .set({
          addedAt: firebase.firestore.FieldValue.serverTimestamp(),
          watchCount: watchCount
        }, { merge: true })
        .then(function() {
          resolve();
        })
        .catch(function(error) {
          console.error(error);
          reject(error);
        });
    });

    return promise;
  }

  updatePaymentTokenWeb(token, currency) {

    let uid = localStorage.getItem('regUserUID')
    let db = firebase.firestore();
    var user = db.collection('users').doc(uid);

    localStorage.removeItem('regUserUID');
    //get login count
    user.get().then((res) => {

     // let user_info = res.data();

      user.set({
          stripeToken: token,
          currency: currency,
          subscribed: false,
          subscriptionPending: true
      }, { merge: true });

    });
  }

  updatePaymentToken(token, currency) {
    let uid = localStorage.getItem('loggedInUserUID')
    let db = firebase.firestore();
    var user = db.collection('users').doc(uid);

    localStorage.removeItem('loggedInUserUID');
    //get login count
    user.get().then((res) => {

     // let user_info = res.data();

      user.set({
          stripeToken: token,
          currency: currency,
          subscribed: false,
          subscriptionPending: true
      }, { merge: true });

    });
  }

  updateOrangePayment(token, lastPayment) {
    let uid = localStorage.getItem('regUserUID')
    let db = firebase.firestore();
    var user = db.collection('users').doc(uid);

    //localStorage.removeItem('regUserUID');
    //get login count
    user.get().then((res) => {

     // let user_info = res.data();

      user.set({
          lastPayment: lastPayment,
          orangeToken: token,
          currency: 'GNF',
          subscribed: true,
          subscriptionPending: false
      }, { merge: true });


    });
  }

  updateOrangePaymentHistory(paymentInfo) {
    let uid = localStorage.getItem('regUserUID')
    let db = firebase.firestore();
    var user = db.collection('users').doc(uid);

    //localStorage.removeItem('regUserUID');
    //get login count
    db.doc(`users/${uid}`).collection('paymentsHistory')
                                    .doc()
                                    .set({
                                        source: 'orange',
                                        addedAt: paymentInfo.payment_date,
                                        paymentInfo: paymentInfo
                                    }).then((data) => {
                                        console.log(data);
                                    }).catch(e => console.log(e));

  }

  handleMovieViews(id) {

    let db = firebase.firestore();
    var title = db.collection('movies').doc(id);
    let status: Number;
    //get login count
    title.get().then((res) => {

      let title_info = res.data();

      console.log(title_info)

      if(title_info.views !== undefined) {

          let newCount = title_info.views + 1;
          title.set({
              views: newCount
          }, { merge: true });

      } else {
        status = 2;

        title.set({
            loginCount: 1
        }, { merge: true });

      }

    });

  }

  handleTvShowViews(id) {

    let db = firebase.firestore();
    var title = db.collection('tvShows').doc(id);
    let status: Number;
    //get login count
    title.get().then((res) => {

      let title_info = res.data();

      console.log(title_info)

      if(title_info.views !== undefined) {

          let newCount = title_info.views + 1;
          title.set({
              views: newCount
          }, { merge: true });

      } else {
        status = 2;

        title.set({
            loginCount: 1
        }, { merge: true });

      }

    });

  }

  updatePushToken(token) {
    let uid = localStorage.getItem('loggedInUserUID')
    let db = firebase.firestore();
    var user = db.collection('users').doc(uid);

    user.set({
        pushToken: token
    }, { merge: true });

  }

  checkIfSubscribed(userId: string) {
    const promise = new Promise((resolve) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .get()
        .then(doc => {
          var user = doc.data();

          if (user.subscribed) {
            resolve({ isSubscribed: user.subscribed });
          }
          else {
            resolve({ isSubscribed: false });
          }
        });
    });

    return promise;
  }

  getMovieWatchProgress(userId: string, videoId) {
    const promise = new Promise((resolve) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentlyWatchedMovies')
        .doc(videoId)
        .get()
        .then(doc => {
          var movie = doc.data();

          if(movie !== undefined) {
            if (movie.watchProgress !== undefined) {
              resolve({ watchProgress: movie.watchProgress });
            }
            else {
              resolve({ watchProgress: 0 });
            }
          } else {
            resolve({ watchProgress: 0 });
          }
        });
    });

    return promise;
  }

  getTvShowWatchProgress(userId: string, videoId) {
    const promise = new Promise((resolve) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('recentlyWatchedTvShows')
        .doc(videoId)
        .get()
        .then(doc => {
          var movie = doc.data();

          if(movie !== undefined) {
            if (movie.watchProgress !== undefined) {
              resolve({ watchProgress: movie.watchProgress });
            }
            else {
              resolve({ watchProgress: 0 });
            }
          } else {
            resolve({ watchProgress: 0 });
          }


        });
    });

    return promise;
  }

  getStripeSubscriptionStatus(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .get()
        .then((res: any) => {
          let user_info = res.data();

          resolve({ status: user_info.subscriptionPending });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/services/FirestoreService.ts